// Post-sign-in destinations. Only same-origin, absolute paths are ever followed, so a stored
// "intended path" can never become an open redirect.

/** Same-origin absolute path (no scheme, no `//host`, no backslashes), otherwise `/`. */
export const safeNext = (next) => {
  if (typeof next !== 'string' || !next.startsWith('/') || next.startsWith('//') || next.includes('\\')) {
    return '/';
  }
  return next;
};

/** Path (+ query) the visitor was trying to reach before being sent to /login. */
export const intendedPath = (locationState) => {
  const from = locationState && locationState.from;
  if (!from || typeof from.pathname !== 'string') return '/';
  return safeNext(`${from.pathname}${from.search || ''}`);
};
